import { render } from "./asynButton.vue?vue&type=template&id=169cae3c&ts=true&lang=pug"
import script from "./asynButton.vue?vue&type=script&lang=ts"
export * from "./asynButton.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/findsoft/hero/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__